import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
  Card,
  Button,
  Stack,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  ListGroup,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import "components/Products/Products.css";

export default function ProductListItem({ listItem }) {
  const getStatusColor = () => {
    if (listItem?.status_sort === "Certified") {
      return "bg-green";
    } else if (listItem?.status_sort === "Archived") {
      return "bg-archived";
    } else {
      return "bg-yellow";
    }
  };

  const getCardName = () => {
    return listItem?.status_sort;
  };

  return (
    <Card className="shadow bg-product">
      <Row>
        <Col xs={2} sm={2} md={1}>
          <div className={"list-card-bar " + getStatusColor()}></div>
        </Col>
        <Col xs={6} sm={7} md={8}>
          <Card.Body>
            <Card.Text>
              <small>{listItem?.vendor_id_name}</small>
            </Card.Text>
            <Card.Title
              className="pb-3 fw-bold"
              data-testid="productListItemName"
            >
              {listItem?.product_name}
            </Card.Title>
            <Row className="d-flex flex-wrap" direction="horizontal">
              {listItem?.status_sort === "Certified" && (
                <>
                  <Stack>
                    <p className="mb-0">Certification Date</p>
                    <strong>
                      {moment
                        .utc(listItem?.certification_date)
                        .format("MM/DD/YYYY")}
                    </strong>
                  </Stack>
                  <Stack className="card-info">
                    <p className="mb-0">Assurance Maintenance Date</p>
                    <strong>
                      {moment.utc(listItem?.am_sort).format("MM/DD/YYYY")}
                    </strong>
                  </Stack>
                </>
              )}
              {listItem?.status_sort === "In Progress" && (
                <Col>
                  <p className="mb-0">Kickoff Date</p>
                  <strong>
                    {moment.utc(listItem?.kicked_off_date).format("MM/DD/YYYY")}
                  </strong>
                </Col>
              )}
              <Col className="card-info">
                <p className="mb-0">Conformance Claims:</p>
                <ListGroup>
                  {listItem?.protection_profiles?.map((pp) => (
                    <OverlayTrigger
                      key={`${listItem?.product_id}-${pp?.pp_id}`}
                      placement="left"
                      overlay={<Tooltip>{pp?.pp_name}</Tooltip>}
                    >
                      <div>
                        <Link to={`/protectionprofiles/${pp?.pp_id}`}>
                          <strong className="py-0 my-0 overflow-ellipsis">
                            {pp?.pp_short_name || pp?.pp_name}
                          </strong>
                        </Link>
                      </div>
                    </OverlayTrigger>
                  ))}
                </ListGroup>
              </Col>
              <Col>
                <p className="mb-0">CCTL</p>
                <strong>{listItem?.assigned_lab_name}</strong>
              </Col>
              {listItem?.from_cc_portal ? (
                <div></div>
              ) : (
                <Col>
                  <p className="mb-0">VID</p>
                  <strong>{listItem?.v_id}</strong>
                </Col>
              )}
            </Row>
          </Card.Body>
        </Col>
        <Col xs={4} sm={3} md={3} className="ms-auto pe-5">
          <Stack>
            <h6 className="text-sm-end text-xs-start my-3">
              <FontAwesomeIcon
                icon={faCircle}
                className="me-1"
                color={
                  listItem?.status_sort === "Archived"
                    ? "var(--bs-orange)"
                    : listItem?.status_sort === "Certified"
                      ? "var(--bs-green)"
                      : "var(--bs-yellow)"
                }
                size="xs"
              />
              {getCardName()}
            </h6>
            {listItem?.submitting_country_id_code && (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="button-tooltip-2">
                    {listItem?.submitting_country_id_name}
                  </Tooltip>
                }
              >
                {({ ref, ...triggerHandler }) => (
                  <div className="text-end pe-1">
                    <img
                      ref={ref}
                      {...triggerHandler}
                      src={`/images/flags2/${listItem?.submitting_country_id_code?.toLowerCase()}.png`}
                      height="50px"
                      width="50px"
                      alt="Country Flag"
                    />
                  </div>
                )}
              </OverlayTrigger>
            )}
            {listItem?.status_sort === "Certified" && (
              <Link
                to={
                  !listItem?.from_cc_portal
                    ? `/products/${listItem?.product_id}`
                    : `/products/international-product/${listItem?.product_id}`
                }
                className="text-sm-end text-xs-start mt-3 mb-3"
              >
                <Button
                  variant="light"
                  size="sm"
                  className="border-dark btn-hover"
                >
                  Full Details
                </Button>
              </Link>
            )}
          </Stack>
        </Col>
      </Row>
    </Card>
  );
}
